module.exports = __webpack_public_path__ + "images/players-club-e106513598bff2771104dffae1da2b38.png";